import * as types from './types';
import createReducer from '../../createReducer';

const initialState = {
  adhocs: [],
  rulesets: [],
  pagination: {},
  current: {
    rules: [],
  },
  rulesetVehicleGroups: [],
  rulesetVehicleGroupsPagination: {},
  currentTaxRuleset: {
    name: '',
    taxes: [],
    description: '',
  },
  loading: false,
  taxRulesets: {
    data: [],
    pagination: {},
  },
  skusAssociated: {
    loading: false,
    list: [],
    pagination: {},
  },
  pricingTypes: [],
  accountingTypes: [],
  fetchingAdhocs: false,
  fetchingRuleset: false,
  fetchingRulesets: false,
  fetchedAddRuleset: false,
  currentTaxRulesetId: null,
  fetchingTaxRuleset: false,
  fetchingTaxRulesets: false,
  fetchingPricingTypes: false,
  fetchingCreateRuleset: false,
  fetchedPricingVehicleGroups: false,
  fetchedCreateRuleset: false,
  fetchedUpdateRuleset: false,
  fetchingUpdateRuleset: false,
  fetchedCreateTaxRuleset: false,
  fetchedUpdateTaxRuleset: false,
  fetchingCreateTaxRuleset: false,
  fetchingUpdateTaxRuleset: false,
  onboarding: {
    exitOnboarding: false,
    currentRuleset: '',
    exitStep: false,
    lastStep: false,
    position: 0,
    errors: {},
    steps: {},
  },
};

const commentsReducer = createReducer(initialState)({
  [types.FETCH_AD_HOC_TYPES_REQUEST]: (state) => {
    return {
      ...state,
      adhocs: [],
      fetchingAdhocs: true,
    };
  },
  [types.FETCH_AD_HOC_TYPES_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      adhocs: payload,
      fetchingAdhocs: false,
    };
  },
  [types.FETCH_AD_HOC_TYPES_FAILED]: (state, { errors }) => {
    return {
      ...state,
      errors: errors,
      fetchingAdhocs: false,
    };
  },

  [types.FETCH_AD_HOC_TYPES_BY_ID_REQUEST]: (state) => {
    return {
      ...state,
      adhocs: [],
      fetchingAdhocs: true,
    };
  },
  [types.FETCH_AD_HOC_TYPES_BY_ID_SUCCESS]: (state, { payload, list }) => {
    let data;

    if (list) {
      data = {
        adhocs: [payload],
      };
    } else {
      data = {
        adhoc: payload,
      };
    }

    return {
      ...state,
      ...data,
      fetchingAdhocs: false,
    };
  },
  [types.FETCH_AD_HOC_TYPES_BY_ID_FAILED]: (state, { errors }) => {
    return {
      ...state,
      errors: errors,
      fetchingAdhocs: false,
    };
  },

  [types.FETCH_PRICING_TYPES_REQUEST]: (state) => {
    return {
      ...state,
      fetchingPricingTypes: true,
    };
  },
  [types.FETCH_PRICING_TYPES_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      pricingTypes: payload,
      fetchingPricingTypes: false,
    };
  },
  [types.FETCH_PRICING_TYPES_FAILED]: (state, { errors }) => {
    return {
      ...state,
      errors: errors,
      fetchingPricingTypes: false,
    };
  },

  [types.FETCH_RULESETS_REQUEST]: (state) => {
    return {
      ...state,
      rulesets: [],
      fetchingRulesets: true,
    };
  },
  [types.FETCH_RULESETS_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      rulesets: payload.data,
      fetchingRulesets: false,
      pagination: payload.pagination,
    };
  },
  [types.FETCH_RULESETS_FAILED]: (state, { errors }) => {
    return {
      ...state,
      errors: errors,
      fetchingRulesets: false,
    };
  },

  [types.FETCH_TAX_RULESETS_REQUEST]: (state) => {
    return {
      ...state,
      taxRulesets: {
        data: [],
        pagination: {},
      },
      fetchingTaxRulesets: true,
    };
  },
  [types.FETCH_TAX_RULESETS_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      taxRulesets: {
        data: payload.data,
        pagination: payload.pagination,
      },
      fetchingTaxRulesets: false,
    };
  },
  [types.FETCH_TAX_RULESETS_FAILED]: (state, { errors }) => {
    return {
      ...state,
      errors: errors,
      fetchingTaxRulesets: false,
    };
  },

  [types.FETCH_RULESET_REQUEST]: (state) => {
    return {
      ...state,
      current: {
        rules: [],
      },
      fetchingRuleset: true,
    };
  },
  [types.FETCH_RULESET_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      current: payload,
      fetchingRuleset: false,
    };
  },
  [types.FETCH_RULESET_FAILED]: (state, { errors }) => {
    return {
      ...state,
      errors: errors,
      fetchingRuleset: false,
    };
  },

  [types.FETCH_UPDATE_RULESET_REQUEST]: (state) => {
    return {
      ...state,
      fetchingUpdateRuleset: true,
      fetchedUpdateRuleset: false,
    };
  },
  [types.FETCH_UPDATE_RULESET_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      fetchingUpdateRuleset: false,
      currentId: payload?.data?.id || payload?.id,
      fetchedUpdateRuleset: true,
    };
  },
  [types.FETCH_UPDATE_RULESET_FAILED]: (state, { errors }) => {
    return {
      ...state,
      fetchingUpdateRuleset: false,
    };
  },

  [types.FETCH_DELETE_RULESET_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
    };
  },
  [types.FETCH_DELETE_RULESET_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      loading: true,
    };
  },
  [types.FETCH_DELETE_RULESET_FAILED]: (state) => {
    return {
      ...state,
      loading: false,
    };
  },

  [types.FETCH_ACCOUNTING_TYPES_REQUEST]: (state) => {
    return {
      ...state,
      accountingTypes: [],
      fetchingAccountingTypes: true,
    };
  },
  [types.FETCH_ACCOUNTING_TYPES_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      accountingTypes: payload,
      fetchingAccountingTypes: false,
    };
  },
  [types.FETCH_ACCOUNTING_TYPES_FAILED]: (state, { errors }) => {
    return {
      ...state,
      errors: errors,
      fetchingAccountingTypes: false,
    };
  },

  [types.FETCH_CREATE_RULESET_REQUEST]: (state) => {
    return {
      ...state,
      fetchingCreateRuleset: true,
    };
  },
  [types.FETCH_CREATE_RULESET_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      current: payload?.data || payload,
      currentId: payload?.data?.id || payload?.id,
      fetchingCreateRuleset: false,
      fetchedCreateRuleset: true,
    };
  },
  [types.FETCH_CREATE_RULESET_FAILED]: (state, { errors }) => {
    return {
      ...state,
      errors: errors,
      fetchingCreateRuleset: false,
      fetchedCreateRuleset: false,
    };
  },

  // ONBOARDING CHANGE POSITION
  [types.CHANGE_POSITION]: (state, { payload }) => {
    let data = {};
    if (payload.data && payload.step) {
      data = {
        steps: {
          ...state.onboarding?.steps,
          ...payload.data,
        },
      };
    }
    return {
      ...state,
      onboarding: {
        ...state.onboarding,
        position: payload.position,
        ...data,
      },
    };
  },

  // FETCH RULE
  [types.FETCH_RULE_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      onboarding: {
        ...state.onboarding,
        steps: {
          ...state.onboarding.steps,
          ...payload,
        },
      },
    };
  },

  // FETCH REMOVE RULE
  [types.FETCH_REMOVE_RULE_SUCCESS]: (state, { payload }) => {
    let data = state.current?.rules ? state.current?.rules : [];

    data.splice(payload?.index, 1);

    return {
      ...state,
      current: {
        ...state?.current,
        rules: data,
      },
    };
  },

  // FETCH UPDATE RULES
  [types.FETCH_UPDATE_RULES_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      currentId: payload?.id,
      current: {
        ...state?.current,
        rules: payload?.rules || [],
      },
    };
  },

  // FETCH UPDATE RULES
  [types.FETCH_UPDATE_RULE_BY_ID_SUCCESS]: (state, { payload }) => {
    const data = state?.current?.rules || [];
    data[payload.index] = payload.rule;
    return {
      ...state,
      current: {
        ...state?.current,
        rules: data,
      },
    };
  },
  // FETCH UPDATE RULESET INFO
  [types.FETCH_UPDATE_RULESET_INFO_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      current: {
        ...state?.current,
        ...payload,
      },
    };
  },
  // RESET ONBOARDING
  [types.RESET_ONBOARDING]: (state) => {
    return {
      ...state,
      fetchedAddRuleset: false,
      fetchingCreateRuleset: false,
      fetchedCreateRuleset: false,
      onboarding: {
        exitOnboarding: false,
        currentRuleset: '',
        exitStep: false,
        lastStep: false,
        position: 0,
        errors: {},
        steps: {},
      },
    };
  },
  // RESET CURRENT RULESET
  [types.RESET_CURRENT_RULESET]: (state) => {
    return {
      ...state,
      fetchedAddRuleset: false,
      fetchingUpdateRuleset: false,
      fetchedUpdateRuleset: false,
      fetchingCreateRuleset: false,
      fetchedCreateRuleset: false,
      current: {
        rules: [],
      },
    };
  },

  [types.SET_EXIT]: (state, { payload }) => {
    return {
      ...state,
      onboarding: {
        ...state.onboarding,
        [payload.type]: payload.exit,
      },
    };
  },

  // FETCH ADD RULESET
  [types.FETCH_ADD_RULESET_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
      fetchedAddRuleset: false,
    };
  },
  [types.FETCH_ADD_RULESET_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      loading: false,
      current: {
        ...state?.current,
        rules: [...(state?.current?.rules ? state?.current?.rules : []), payload],
      },
      fetchedAddRuleset: true,
    };
  },
  [types.FETCH_ADD_RULESET_FAILED]: (state, { errors }) => {
    return {
      ...state,
      loading: false,
      onboarding: {
        ...state.onboarding,
        errors,
      },
      fetchedAddRuleset: false,
    };
  },
  // FETCH RULESET VG's
  [types.FETCH_RULESET_VEHICLE_GROUPS_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
      fetchedPricingVehicleGroups: false,
    };
  },
  [types.FETCH_RULESET_VEHICLE_GROUPS_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      loading: false,
      rulesetVehicleGroups: payload?.data,
      rulesetVehicleGroupsPagination: payload?.pagination,
      fetchedPricingVehicleGroups: true,
    };
  },
  [types.FETCH_RULESET_VEHICLE_GROUPS_FAILED]: (state, { errors }) => {
    return {
      ...state,
      loading: false,
      fetchedPricingVehicleGroups: false,
    };
  },
  // FETCH ADD TAX RULESET
  [types.FETCH_ADD_TAX_RULESET_REQUEST]: (state) => {
    return {
      ...state,
      fetchingAddTaxRuleset: true,
      fetchedAddTaxRuleset: false,
    };
  },
  [types.FETCH_ADD_TAX_RULESET_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      fetchingAddTaxRuleset: false,
      currentTaxRuleset: {
        ...state?.currentTaxRuleset,
        taxes: [...(state?.currentTaxRuleset?.taxes || []), payload],
      },
      fetchedAddTaxRuleset: true,
    };
  },

  // FETCH SKUs ASSOCIATED
  [types.FETCH_ADD_TAX_RULESET_REQUEST]: (state) => {
    return {
      ...state,
      skusAssociated: {
        ...state.skusAssociated,
        loading: true,
      },
    };
  },
  [types.FETCH_SKUS_ASSOCIATED_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      skusAssociated: {
        ...state.skusAssociated,
        loading: false,
        list: payload.data,
        pagination: payload.pagination,
      },
    };
  },
  [types.FETCH_SKUS_ASSOCIATED_FAILED]: (state) => {
    return {
      ...state,
      skusAssociated: {
        ...state.skusAssociated,
        loading: false,
      },
    };
  },

  // FETCH REMOVE RULE
  [types.FETCH_REMOVE_TAXES]: (state, { payload }) => {
    return {
      ...state,
      currentTaxRuleset: {
        ...state?.currentTaxRuleset,
        taxes: payload,
      },
    };
  },
  [types.FETCH_UPDATE_TAXES]: (state, { payload }) => {
    return {
      ...state,
      currentTaxRuleset: {
        ...state?.currentTaxRuleset,
        taxes: payload,
      },
    };
  },
  [types.FETCH_UPDATE_TAXES_ORDER]: (state, { payload }) => {
    return {
      ...state,
      currentTaxRuleset: {
        ...state?.currentTaxRuleset,
        taxes: payload,
      },
    };
  },

  [types.FETCH_UPDATE_TAX_RULESET_INFO]: (state, { payload }) => {
    return {
      ...state,
      currentTaxRuleset: {
        ...state?.currentTaxRuleset,
        ...payload,
      },
    };
  },

  [types.FETCH_RESET_TAX_RULESET]: (state, { errors }) => {
    return {
      ...state,
      errors: errors,
      currentTaxRuleset: {},
      fetchedCreateTaxRuleset: false,
      fetchingCreateTaxRuleset: false,
    };
  },

  [types.FETCH_CREATE_TAX_RULESET_REQUEST]: (state) => {
    return {
      ...state,
      fetchingCreateTaxRuleset: true,
      fetchedCreateTaxRuleset: false,
    };
  },
  [types.FETCH_CREATE_TAX_RULESET_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      fetchedCreateTaxRuleset: true,
      fetchingCreateTaxRuleset: false,
      currentTaxRuleset: {
        ...(payload?.data || payload),
        taxes: [...(payload?.data?.tax_rates || payload?.tax_rates || [])],
      },
      currentTaxRulesetId: payload?.data?.id || payload?.id,
    };
  },
  [types.FETCH_CREATE_TAX_RULESET_FAILED]: (state, { errors }) => {
    return {
      ...state,
      errors: errors,
      fetchedCreateTaxRuleset: false,
      fetchingCreateTaxRuleset: false,
    };
  },

  [types.FETCH_UPDATE_TAX_RULESET_REQUEST]: (state) => {
    return {
      ...state,
      fetchingUpdateTaxRuleset: true,
      fetchedUpdateTaxRuleset: false,
    };
  },
  [types.FETCH_UPDATE_TAX_RULESET_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      fetchedUpdateTaxRuleset: true,
      fetchingUpdateTaxRuleset: false,
      currentTaxRuleset: {
        ...(payload?.data || payload),
        taxes: [...(payload?.data?.tax_rates || payload?.tax_rates || [])],
      },
      currentTaxRulesetId: payload?.data?.id || payload?.id,
    };
  },
  [types.FETCH_UPDATE_TAX_RULESET_FAILED]: (state, payload) => {
    return {
      ...state,
      errors: payload,
      fetchedUpdateTaxRuleset: false,
      fetchingUpdateTaxRuleset: false,
    };
  },

  [types.FETCH_TAX_RULESET_BY_ID_REQUEST]: (state) => {
    return {
      ...state,
      currentTaxRuleset: {
        taxes: [],
      },
      taxRulesets: {
        data: [],
        pagination: {},
      },
      fetchingTaxRuleset: true,
    };
  },
  [types.FETCH_TAX_RULESET_BY_ID_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      currentTaxRuleset: {
        ...payload,
        taxes: payload.tax_rates,
      },
      fetchingTaxRuleset: false,
    };
  },
  [types.FETCH_TAX_RULESET_BY_ID_FAILED]: (state, { errors }) => {
    return {
      ...state,
      errors: errors,
      fetchingTaxRuleset: false,
    };
  },
  [types.FETCH_DELETE_TAX_RULESET_REQUEST]: (state) => {
    return {
      ...state,
      fetchingRulesets: true,
    };
  },
  [types.FETCH_DELETE_TAX_RULESET_SUCCESS]: (state) => {
    return {
      ...state,
      fetchingRulesets: true,
    };
  },
  [types.FETCH_DELETE_TAX_RULESET_FAILED]: (state) => {
    return {
      ...state,
      fetchingRulesets: false,
    };
  },
  [types.RESET_CURRENT_TAX_RULESET]: (state) => {
    return {
      ...state,
      currentTaxRuleset: {
        name: '',
        taxes: [],
        description: '',
      },
      taxRulesets: {
        data: [],
        pagination: {},
      },
      fetchedUpdateTaxRuleset: false,
      fetchedCreateTaxRuleset: false,
      fetchingCreateTaxRuleset: false,
      fetchingUpdateTaxRuleset: false,
    };
  },
  [types.RESET_AD_HOC_TYPES]: (state) => {
    return {
      ...state,
      adhocs: [],
    };
  },
});

export default commentsReducer;
